<!--
  Zero-size, pointer-transparent origin pinned to the middle of the viewport.
  It is what a centred card (a Settings preview of a tip anchored on another
  page) positions against, so anchored and centred tips share one overlay.
-->
<span class="ftue-layer__viewport-centre" #viewportCentre></span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayViewportMargin]="20"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayHasBackdrop]="false"
  (overlayOutsideClick)="onDismiss('outside')"
  (detach)="onDetach()"
>
  <ui-coach-mark
    *ngIf="presentation"
    [tip]="presentation.tip"
    [isPreview]="presentation.isPreview"
    (dismissed)="onDismiss($event)"
    (settingsRequested)="onSettingsRequested()">
  </ui-coach-mark>
</ng-template>
